'use client';

import { useWindowSize } from "@/hooks/useWindowSize";
import Image from "next/image";
import React from "react";
import dynamic from "next/dynamic";
const SlideInWrapper = dynamic(() => import("../motion/SlideInWrapper"));

const steps = [
  {
    number: "01",
    title: "It makes you Practice Daily",
    subtitle: "& build a long lasting habit",
    description:
      "Set your own daily goal, build your streak and never miss a day.",
    linkText: "See in Detail",
    imageSrc: "/assets/stepperPage/Frame_3A.svg",
    imageNoSrc: "/assets/stepperPage/01.svg",
    imageAlt: "Step 1 Image",
    position: "left",
  },
  {
    number: "02",
    title: "It makes you Master Every Topic",
    subtitle: "& fix your weak areas",
    description:
      "Solve PYQs, and focused questions for each topic. Get better with every quiz. No gaps left behind.",
    linkText: "See in Detail",
    imageSrc: "/assets/stepperPage/Frame_3B.svg",
    imageNoSrc: "/assets/stepperPage/02.svg",
    imageAlt: "Step 2 Image",
    position: "right",
  },
  {
    number: "03",
    title: "It helps you Revise Smarter",
    subtitle: "& never forget what you learn",
    description:
      "Revisions are automatically timed to when your memory fades in that topic. Convert short-term into long-term memory.",
    linkText: "See in Detail",
    imageSrc: "/assets/stepperPage/Frame_3C.svg",
    imageNoSrc: "/assets/stepperPage/03.svg",
    imageAlt: "Step 3 Image",
    position: "left",
  },
  {
    number: "04",
    title: "It helps you Track your Progress",
    subtitle: "& see real improvement every day",
    description:
      "See your effort turn into visible progress. Track stats, points, and achievements as you improve.",
    linkText: "See in Detail",
    imageSrc: "/assets/stepperPage/Frame_3D.svg",
    imageNoSrc: "/assets/stepperPage/04.svg",
    imageAlt: "Step 4 Image",
    position: "right",
  },
];

const StepperSection = () => {
  const {width} = useWindowSize()
  return (
    <section className="py-20 px-8">
      <div className="container mx-auto text-center">
        <h2 className="text-4xl font-extrabold mb-2">Try the NetPractice</h2>
        <h3 className="text-4xl font-extrabold text-blue-500 text-primary mb-4">
          Revision System
        </h3>
        <p className="text-neutral-700 text-sm">
          A smart system to increase your learning power in the exam day
        </p>
        <div className="relative flex flex-col items-center max-w-7xl mx-auto pt-5 pb-16">
        <div
            className={`lg:flex hidden absolute bg-[url('/assets/orange_lite_bg.svg')] top-[160px] bg-cover bg-center z-10 flex-shrink-0 w-16 h-16 bg-orange-500 text-white rounded-full  items-center justify-center text-2xl font-bold mb-4 lg:mb-0`}
          >
            1
          </div>
          <div
            className={`lg:flex hidden absolute bg-[url('/assets/orange_lite_bg.svg')] top-[500px] bg-cover bg-center z-10 flex-shrink-0 w-16 h-16 bg-orange-500 text-white rounded-full  items-center justify-center text-2xl font-bold mb-4 lg:mb-0`}
          >
            2
          </div>
          <div
            className={`lg:flex hidden absolute bg-[url('/assets/orange_lite_bg.svg')] top-[800px] bg-cover bg-center z-10 flex-shrink-0 w-16 h-16 bg-orange-500 text-white rounded-full  items-center justify-center text-2xl font-bold mb-4 lg:mb-0`}
          >
            3
          </div>
          <div
            className={`lg:flex hidden absolute bg-[url('/assets/orange_lite_bg.svg')] top-[1100px] bg-cover bg-center z-10 flex-shrink-0 w-16 h-16 bg-orange-500 text-white rounded-full  items-center justify-center text-2xl font-bold mb-4 lg:mb-0`}
          >
            4
          </div>
          <div
            className={`lg:flex hidden absolute bg-[url('/assets/blue_design_bg.svg')] bottom-[-110px] bg-cover bg-center outline-[5px] outline-white z-10 flex-shrink-0 w-16 h-16 bg-orange-500 text-white rounded-full  items-center justify-center text-2xl font-bold mb-4 lg:mb-0`}
          >
            5
          </div>
          <div className="w-1 bg-orange-500 absolute left-1/2 transform -translate-x-1/2 top-40 bottom-[-60px] z-[-1] lg:block hidden animate-line" /> 

          {steps.map((step, index) => (
            <div
              key={index}
              className={`w-full flex flex-col-reverse lg:flex-row gap-20 lg:gap-0 items-center ${
                step.position === "right" ? "lg:flex-row-reverse" : ""
              } mb-16 relative z-10`}
            >
              {/* {console.log(index, Number(index), Number(index) % 2 == 0, width)} */}
             {width > 1024
             ?  
             <div
                  className={`text-${
                    Number(index) % 2 == 0 ? "right" : "left"
                  } w-1/2 px-12`}
                >
                <SlideInWrapper direction={Number(index) % 2 == 0 ? "left" : "right"} delay={index * 0.3}>
                  <p className={`text-xl font-bold mb-1`}>{step.title}</p>
                  <p className="text-xl font-bold text-blue-500 mb-4">
                    {step.subtitle}
                  </p>
                  <p className="text-neutral-700 text-md font-medium mb-4">
                    {step.description}
                  </p>
                  <a href="#" className="text-orange-500 font-semibold btn" aria-label="app text" title="app text">
                    {step.linkText} &rarr;
                  </a>
                  </SlideInWrapper>
                </div>
                
              :<div
                className={`w-full flex ${
                    Number(index) % 2 == 0 ? "flex-row justify-between" : "flex-row-reverse"
                  }`}
              >
                <div
                  className={`px-2 text-${
                    Number(index) % 2 == 0 ? "left" : "right"
                  }`}
                >
                <SlideInWrapper direction={Number(index) % 2 == 0 ? "left" : "right"} delay={index * 0.2}>
                  <p className="text-xl font-bold mb-1">{step.title}</p>
                  <p className="text-xl font-bold text-blue-500 mb-4">
                    {step.subtitle}
                  </p>
                  <p className="text-neutral-700 text-sm font-medium mb-4">
                    {step.description}
                  </p>
                  <a href="#" className="text-orange-500 font-semibold btn" aria-label="app text" title="app text">
                    {step.linkText} &rarr;
                  </a>
                  </SlideInWrapper>
                </div>
                 <div
                    className={`block lg:hidden px-2 text-${
                      Number(index) % 2 == 0 ? "right" : "left"
                    }`}
                  >
                    <Image
                      src={step.imageNoSrc}
                      alt={step.imageAlt}
                      width={120}
                      height={80}
                      // className="object-cover"
                    />
                  </div>
              </div>
             }
              <div className="w-[85%] lg:w-1/2 flex justify-center">
                <Image
                  src={step.imageSrc}
                  alt={step.imageAlt}
                  width={380}
                  height={280}
                  className="object-cover"
                />
              </div>
            </div>
          ))}
          

        </div>
      </div>
    </section>
  );
};

export default StepperSection;
